module.exports = __webpack_public_path__ + "img/cancun-bay-restaurant.93ad1545.jpg";